import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-estimated-tax-savings',
  templateUrl: './estimated-tax-savings.component.html',
  styleUrls: ['./estimated-tax-savings.component.scss']
})
export class EstimatedTaxSavingsComponent implements OnInit {

  constructor(private dialogRef: MatDialogRef<EstimatedTaxSavingsComponent>) { }

  ngOnInit(): void {
  }

  onClose() {
    this.dialogRef.close();
  }


}
